import { IconsProps } from '@/types/shared'
import React from 'react'

const CustomerQualifiedProspectIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 15 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.55837 11.5L7.83337 10.125L10.1084 11.5L9.50837 8.9L11.5084 7.175L8.88337 6.95L7.83337 4.5L6.78337 6.95L4.15837 7.175L6.15837 8.9L5.55837 11.5ZM0.833374 18.5V2.5C0.833374 1.95 1.02921 1.47917 1.42087 1.0875C1.81254 0.695833 2.28337 0.5 2.83337 0.5H12.8334C13.3834 0.5 13.8542 0.695833 14.2459 1.0875C14.6375 1.47917 14.8334 1.95 14.8334 2.5V18.5L7.83337 15.5L0.833374 18.5ZM2.83337 15.45L7.83337 13.3L12.8334 15.45V2.5H2.83337V15.45Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default CustomerQualifiedProspectIcons
